"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagBI = function FlagBI(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54-122H-185.94a7.06,7.06,0,0,0-7.06,7.06V139.3a7.06,7.06,0,0,0,7.06,7.06H209.54a7.06,7.06,0,0,0,7.06-7.06V-114.94a7.06,7.06,0,0,0-7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-160.79-122,11.8-8.93,184.39-122Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M184.39,146.44,11.8,33.37-160.79,146.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-114.94a7.06,7.06,0,0,0-7.06-7.06H184.39L53.16-36a63.37,63.37,0,0,0-82.72,0l-131.23-86h-25.15a7.06,7.06,0,0,0-7.06,7.06v14L-48.95-6.52a63.63,63.63,0,0,0,0,37.4l-144,94.37V139.3a7.06,7.06,0,0,0,7.06,7.06h25.15l131.23-86a63.37,63.37,0,0,0,82.72,0l131.23,86h25.15a7.06,7.06,0,0,0,7.06-7.06V125.25l-144-94.37a63.63,63.63,0,0,0,0-37.4L216.6-100.89Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.22-8.14l-9.57.25,5-8.18-5-8.17L7.22-24l4.58-8.42L16.38-24,26-24.24l-5,8.17,5,8.18-9.57-.25L11.8.28Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-30.19l3.95,7.27L24-23.13l-4.32,7.06L24-9l-8.28-.21L11.8-1.94l-4-7.28L-.43-9l4.32-7.06L-.43-23.13l8.27.21,4-7.27m0-4.44L9.94-31.2,6.6-25.07l-7-.18-3.89-.1,2,3.33,3.65,5.95-3.65,6-2,3.32,3.89-.1,7-.18L9.94-.93,11.8,2.49,13.66-.93,17-7.07l7,.18,3.89.1-2-3.32-3.65-6L25.84-22l2-3.33-3.89.1-7,.18L13.66-31.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-19.07,38.66l-9.58.25,5-8.17-5-8.17,9.58.25,4.57-8.42,4.58,8.42,9.57-.25-5,8.17,5,8.17-9.57-.25-4.58,8.42Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-14.5,16.61l4,7.28,8.27-.21-4.32,7.06,4.32,7.06-8.27-.21-4,7.27-3.95-7.27-8.28.21,4.32-7.06-4.32-7.06,8.28.21,3.95-7.28m0-4.43-1.86,3.42-3.34,6.14-7-.18-3.89-.1,2,3.32,3.64,6-3.64,6-2,3.32,3.89-.1,7-.18,3.34,6.14,1.86,3.42,1.86-3.42,3.34-6.14,7,.18,3.89.1-2-3.32-3.65-6,3.65-6,2-3.32-3.89.1-7,.18-3.34-6.14Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M33.52,38.66,24,38.91l5-8.17-5-8.17,9.57.25L38.1,14.4l4.58,8.42,9.57-.25-5,8.17,5,8.17-9.57-.25L38.1,47.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38.1,16.61l3.95,7.28,8.28-.21L46,30.74l4.32,7.06-8.28-.21L38.1,44.86l-4-7.27-8.27.21,4.32-7.06-4.32-7.06,8.27.21,4-7.28m0-4.43L36.24,15.6,32.9,21.74l-7-.18-3.9-.1,2,3.32,3.64,6-3.64,6L22,40l3.9-.1,7-.18,3.34,6.14L38.1,49.3,40,45.88l3.34-6.14,7,.18,3.89.1-2-3.32-3.65-6,3.65-6,2-3.32-3.89.1-7,.18L40,15.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagBI;
exports["default"] = _default;